import moment from "moment";
import API_URLS from "../helper/api-urls";
import ApiHelper from "../helper/api-helper";

const addStaff = (fields) => {
  const data = {
    firstName: fields.firstName,
    lastName: fields.lastName,
    middleName: fields.middleName,
    dob: moment(fields.dob).format("YYYY-MM-DD"),
    email: fields.email,
    masterClinicId: fields.masterClinicId.id,
    userName: fields.userName,
    phone: fields.phone,
    mobile: fields.mobile,
    roleId: fields.roleId.id,
    genderId: fields.genderId.id,
    utcDateCreated: moment(fields.utcDateCreated).format("YYYY-MM-DD"),
    isActive: fields.isActive,
    timeZoneId: fields.timeZoneId.id,
    isSystemUser: fields.isSystemUser
  };

  return ApiHelper.postRequest(API_URLS.ADD_STAFF, data);
};

const updateStaff = (fields, state) => {
  const data = {
    id: state.staffId,
    firstName: fields.firstName,
    lastName: fields.lastName,
    middleName: fields.middleName,
    dob: moment(fields.dob).format("YYYY-MM-DD"),
    email: fields.email,
    masterClinicId: fields.masterClinicId.id,
    address: fields.address,
    city: fields.city,
    state: 0,
    zip: fields.zip,
    phone: fields.phone,
    mobile: fields.mobile,
    genderId: fields.genderId.id,
    utcDateModified: moment(fields.utcDateCreated).format("YYYY-MM-DD"),
    timeZoneId: fields.timeZoneId.id,
    isActive: fields.isActive,
    isSystemUser: fields.isSystemUser
  };

  return ApiHelper.postRequest(API_URLS.UPDATE_STAFF, data);
};

const getStaffById = (state) => {
  return ApiHelper.getRequest(
    API_URLS.GET_STAFF_BY_ID +
    state.staffId +
    "&" +
    "masterClinicId" +
    "=" +
    state.masterClinicId
  );
};

const impersonateStaff = (staffId,masterClinicId) => {
  const body = {
    staffId: staffId,
    masterClinicId: masterClinicId
  };
  return ApiHelper.postRequest(API_URLS.IMPERSONATE_STAFF, body);
};

const sendStaffWelcomeEmail = (staffIds, regionId, masterClinicId) => {
  const body = {
    staffIds: staffIds,
    masterClinicId: masterClinicId,
    regionId: regionId
  }
  return ApiHelper.postRequest(API_URLS.SEND_STAFF_WELCOME_EMAILS, body);
}

export const staffService = {
  addStaff,
  updateStaff,
  getStaffById,
  impersonateStaff,
  sendStaffWelcomeEmail
};
